import type { TemplateShort } from '@queries/fetchTemplates';
import { isEmptyValue } from '@root/helpers';

import type { PublishedTemplate } from '../types';

export const filterPublishedTemplates = (item: TemplateShort): item is PublishedTemplate => {
  return !isEmptyValue(item.name) && item.status === 'PUBLISHED';
};
